import * as Yup from 'yup';
import XRegExp from 'xregexp';

const NAME_EXP = new XRegExp("^[\\(\\)\\/\\-\\+\\,\\'\\s?\\d?\\w+]*$|\\p{Hiragana}\\p{Katakana}\\p{Han}\\p{Hangul}]+");
const MESSAGE = "You can only use the following special characters ( ) / -  + , '";

export default Yup.object().shape({
  firstName: Yup.string()
    .max(30, 'Must be less than 30 characters')
    .matches(NAME_EXP, MESSAGE)
    .required('Required'),

  lastName: Yup.string()
    .max(40, 'Must be less than 40 characters')
    .matches(NAME_EXP, MESSAGE)
    .required('Required'),

  email: Yup.string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Must be a valid email address',
    )
    .required('Required'),

  password: Yup.string()
    .matches(/^.*(?=.{12,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Stronger password required')
    .max(50, 'Must be less than 50 characters')
    .required('Required'),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Must match with password')
    .required('Required'),
});
